<template>
  <div class="caf" role="list">
    <div 
      v-for="{ filterKey, option } in individualFilters"
      :key="filterKey + option"
      class="caf__item"
      role="listitem"
      :aria-labelledby="filterKey"
    >
      <span class="caf__title">{{option}}</span>
      <button 
        class="caf__close" 
        @click="emit('remove-filter', filterKey, option)"
        :aria-label="`Remove filter ${filterKey} ${option}`" 
        :aria-labelledby="filterKey"
      >
        <svg class="caf__close-icon" role="img" aria-hidden="true">
          <use xlink:href="#close"></use>
        </svg>
      </button>
    </div>
    <button class="caf__clear" @click="emit('clear-filter')" tabindex="0" aria-label="Clear All Filters">Clear All</button>
  </div>
</template>

<script setup>
  import {ref, toRefs, computed} from 'vue';
  const props = defineProps({
    filters: {
      type: Object,
      required: true,
    },
  })

  const emit = defineEmits(['remove-filter','clear-filter'])
  const { filters } = toRefs(props)

  const individualFilters = computed(() => {
    return Object.entries(filters.value || {}).reduce(
      (final, [filterKey, filterOptions]) => {
        filterOptions.forEach(option => {
          final.push({
            filterKey,
            option,
          })
        })
        return final
      },
      []
    )
  })

</script>